
<v-select
    :items         = "codes"
    item-value     = "id"
    item-text      = "name"
    label          = "Ländercode"
    v-model        = "seletced"
    :return-object = true
    @change        = "onChange"
    :readonly      = "readonly"
    :hide-details  = "true"
    class          = "country-select"
>
    <template v-slot:item="{ item }">
        {{ item.flag }} {{ item.phone }} {{ item.name }}
    </template>
    <template v-slot:selection="{ item }">
        {{ item.flag }} {{ item.phone }}
    </template>
</v-select>
